const { suppliedLocationContent } = require("./suppliedLocationContentV2");

const locations = [
  {
    name: "Nedunkundram",
    slug: "nedunkundram",
    landmark: "Nedunkundram, SSM Nagar, Alappakam and New Perungalathur",
    intro: "Looking for a family clinic in Nedunkundram, New Perungalathur, or the surrounding areas? Revive Family Clinic & X-ray Diagnostics is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Nedunkundram, Tamil Nadu 600063.",
    travel: "Located in the Nedunkundram area, the clinic is accessible to people living in and around New Perungalathur, SSM Nagar and Alappakam.",
    metaTitle: "Revive Family Clinic & X-ray Diagnostics | Nedunkundram",
    metaDescription: "Looking for a family clinic in Nedunkundram? Visit Revive Family Clinic & X-ray Diagnostics in New Perungalathur. Find clinic information, available services and contact details.",
  },
  {
    name: "New Perungalathur",
    slug: "new-perungalathur",
    landmark: "NGO Nagar Main Road and New Perungalathur",
    intro: "Revive Family Clinic is based in New Perungalathur, providing convenient neighbourhood access to family medicine, diabetes care, orthopaedic consultation and digital X-ray diagnostics.",
    travel: "Patients from across New Perungalathur can reach the clinic via NGO Nagar Main Road without travelling into central Chennai.",
    metaTitle: "Family Clinic in New Perungalathur | Revive X-Ray",
    metaDescription:
      "Find Revive Family Clinic & X-Ray Diagnostics in New Perungalathur for family medicine, general consultation, health check-ups and digital X-ray enquiries.",
  },
  {
    name: "Perungalathur",
    slug: "perungalathur",
    landmark: "Perungalathur railway station and GST Road",
    intro: "Families in Perungalathur can visit Revive for everyday medical concerns, preventive care, long-term condition support, bone and joint assessment and digital imaging.",
    travel: "The clinic is a practical option for residents travelling from Perungalathur railway station, GST Road and surrounding residential streets.",
    metaTitle: "Family Clinic Near Perungalathur | Revive Diagnostics",
    metaDescription:
      "Looking for a family clinic near Perungalathur? Contact Revive in New Perungalathur about general consultation, health check-ups and digital X-ray services.",
  },
  {
    name: "Peerkankaranai",
    slug: "peerkankaranai",
    landmark: "Peerkankaranai and Srinivasa Nagar",
    intro: "Revive supports Peerkankaranai residents with attentive family consultations, diabetes follow-up, orthopaedic care and access to digital X-ray services.",
    travel: "Patients can reach the clinic from Peerkankaranai and Srinivasa Nagar through the New Perungalathur road network.",
    metaTitle: "Family Clinic Near Peerkankaranai | Revive Clinic",
    metaDescription:
      "Peerkankaranai patients can contact Revive Family Clinic in New Perungalathur for family medicine, general consultation, health check-ups and digital X-ray information.",
  },
  {
    name: "Tambaram",
    slug: "tambaram",
    landmark: "Tambaram railway station and GST Road",
    intro: "Patients from Tambaram can access family healthcare and diagnostic support at Revive, including general consultations, preventive guidance, orthopaedic review and digital X-ray.",
    travel: "Revive is accessible from Tambaram through GST Road and the local routes connecting to New Perungalathur.",
    metaTitle: "Family Clinic Near Tambaram | Revive X-Ray Clinic",
    metaDescription:
      "Contact Revive Family Clinic near Tambaram for family medicine, general consultation, health check-ups and digital X-ray information in New Perungalathur.",
  },
  {
    name: "West Tambaram",
    slug: "west-tambaram",
    landmark: "West Tambaram, Mudichur Road and Krishna Nagar",
    intro: "Revive provides West Tambaram families with personalised medical advice, diabetes management support, musculoskeletal care and modern digital imaging.",
    travel: "Residents near Mudichur Road and Krishna Nagar can travel towards New Perungalathur for scheduled consultations and walk-in availability.",
    metaTitle: "Family Clinic Near West Tambaram | Revive Clinic",
    metaDescription:
      "West Tambaram families can enquire with Revive in New Perungalathur about family medicine, general consultation, health check-ups and digital diagnostics.",
  },
  {
    name: "East Tambaram",
    slug: "east-tambaram",
    landmark: "East Tambaram and Selaiyur",
    intro: "For families in East Tambaram, Revive offers coordinated primary care, preventive health guidance, orthopaedic assessment and digital X-ray diagnostics.",
    travel: "The clinic can be reached through Tambaram and GST Road connections, with evening consultation hours for added convenience.",
    metaTitle: "Family Clinic Near East Tambaram | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near East Tambaram, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  {
    name: "Vandalur",
    slug: "vandalur",
    landmark: "Vandalur junction and GST Road",
    intro: "Vandalur residents can consult Revive for family health needs, diabetes monitoring, bone and joint concerns, sports injuries and digital X-ray services.",
    travel: "The clinic is connected to Vandalur through GST Road and the New Perungalathur approach roads.",
    metaTitle: "Family Clinic Near Vandalur | Revive X-Ray",
    metaDescription:
      "Vandalur residents can contact Revive Family Clinic in New Perungalathur about family medicine, general consultation, health check-ups and digital diagnostics.",
  },
  {
    name: "Mannivakkam",
    slug: "mannivakkam",
    landmark: "Mannivakkam and Vandalur-Walajabad Road",
    intro: "Revive welcomes patients from Mannivakkam for general medical consultations, preventive care, diabetes support, orthopaedic evaluation and diagnostic imaging.",
    travel: "Residents can travel via Vandalur and the local road network towards the clinic in New Perungalathur.",
    metaTitle: "Family Clinic Near Mannivakkam | Revive Clinic",
    metaDescription:
      "Mannivakkam patients can enquire with Revive Family Clinic in New Perungalathur about family medicine, general consultation, health check-ups and digital imaging.",
  },
  {
    name: "Mudichur",
    slug: "mudichur",
    landmark: "Mudichur Road and nearby residential communities",
    intro: "Families in Mudichur can access dependable medical consultations, diabetes care, orthopaedic expertise and digital X-ray diagnostics at Revive.",
    travel: "The clinic is reachable through Mudichur Road and the West Tambaram-New Perungalathur corridor.",
    metaTitle: "Family Clinic Near Mudichur | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Mudichur, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  {
    name: "Urapakkam",
    slug: "urapakkam",
    landmark: "Urapakkam railway station and GST Road",
    intro: "Revive serves Urapakkam patients seeking family medicine, preventive health advice, diabetes follow-up, bone and joint care and digital X-ray imaging.",
    travel: "Patients can travel north through GST Road towards New Perungalathur for consultations and diagnostics.",
    metaTitle: "Family Clinic Near Urapakkam | Revive Clinic",
    metaDescription:
      "Urapakkam residents can contact Revive Family Clinic in New Perungalathur for family medicine, general consultation, health check-ups and digital diagnostics.",
  },
  {
    name: "Kilambakkam",
    slug: "kilambakkam",
    landmark: "Kilambakkam bus terminus and GST Road",
    intro: "People living around Kilambakkam can visit Revive for family consultations, chronic-condition support, orthopaedic assessment and digital diagnostic services.",
    travel: "Direct GST Road connectivity makes the clinic accessible from the Kilambakkam bus terminus and nearby communities.",
    metaTitle: "Family Clinic Near Kilambakkam | Revive X-Ray",
    metaDescription:
      "People in Kilambakkam can enquire with Revive Family Clinic in New Perungalathur about family medicine, general consultation, health check-ups and digital X-ray services.",
  },
  {
    name: "Guduvanchery",
    slug: "guduvanchery",
    landmark: "Guduvanchery and GST Road",
    intro: "Revive provides Guduvanchery families with access to primary healthcare, diabetes care, orthopaedic consultation and modern digital X-ray diagnostics.",
    travel: "Residents can reach New Perungalathur by travelling north along GST Road for planned appointments.",
    metaTitle: "Family Clinic Near Guduvanchery | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Guduvanchery, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  {
    name: "Irumbuliyur",
    slug: "irumbuliyur",
    landmark: "Irumbuliyur junction and Tambaram bypass",
    intro: "Revive supports Irumbuliyur residents with neighbourhood family healthcare, preventive guidance, orthopaedic care and reliable digital imaging.",
    travel: "The clinic is close to the New Perungalathur side of the Tambaram corridor and convenient for nearby residential areas.",
    metaTitle: "Family Clinic Near Irumbuliyur | Revive X-Ray",
    metaDescription:
      "Irumbuliyur residents can enquire with Revive Family Clinic in New Perungalathur about family medicine, general consultation, health check-ups and digital imaging.",
  },
  {
    name: "Chromepet",
    slug: "chromepet",
    landmark: "Chromepet, GST Road and Radha Nagar",
    intro: "Patients from Chromepet can choose Revive for attentive consultations, diabetes management, orthopaedic assessment and digital X-ray support.",
    travel: "GST Road provides a straightforward route south from Chromepet to the clinic in New Perungalathur.",
    metaTitle: "Family Clinic Near Chromepet | Revive Clinic",
    metaDescription:
      "Chromepet patients can contact Revive Family Clinic in New Perungalathur for family medicine, general consultation, health check-ups and X-ray enquiries.",
  },
  {
    name: "Pallavaram",
    slug: "pallavaram",
    landmark: "Pallavaram and GST Road",
    intro: "Revive welcomes Pallavaram families for general healthcare, preventive check-ups, diabetes care, bone and joint consultation and digital diagnostics.",
    travel: "Patients can follow GST Road towards Tambaram and New Perungalathur to reach the clinic.",
    metaTitle: "Family Clinic Near Pallavaram | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Pallavaram, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  {
    name: "Selaiyur",
    slug: "selaiyur",
    landmark: "Selaiyur, Camp Road and East Tambaram",
    intro: "Residents of Selaiyur can access family consultations, preventive care, diabetes support, orthopaedic review and digital X-ray diagnostics at Revive.",
    travel: "The clinic is reachable through East Tambaram and the road connections leading to New Perungalathur.",
    metaTitle: "Family Clinic Near Selaiyur | Revive Clinic",
    metaDescription:
      "Selaiyur families can enquire with Revive Family Clinic in New Perungalathur about family medicine, general consultation, health check-ups and digital X-ray diagnostics.",
  },
  {
    name: "Padappai",
    slug: "padappai",
    landmark: "Padappai and Vandalur-Walajabad Road",
    intro: "Revive offers Padappai patients family healthcare, diabetes monitoring, orthopaedic consultation and digital imaging in a patient-friendly setting.",
    travel: "Travel through Mannivakkam and Vandalur provides access to the clinic in New Perungalathur.",
    metaTitle: "Family Clinic Near Padappai | Revive Diagnostics",
    metaDescription:
      "Padappai patients can contact Revive Family Clinic in New Perungalathur for family medicine, general consultation, health check-ups and digital diagnostic support.",
  },
];

// These metadata values mirror the supplied SEO briefs. Keep them separate from
// the descriptive location copy so future content changes do not accidentally
// alter the route's title or description.
const suppliedSeoMetadata = {
  peerkankaranai: {
    metaTitle: "Family Clinic Near Peerkankaranai | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Peerkankaranai, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  vandalur: {
    metaTitle: "Family Clinic Near Vandalur | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Vandalur, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  tambaram: {
    metaTitle: "Family Clinic Near Tambaram | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Tambaram, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  urapakkam: {
    metaTitle: "Family Clinic Near Urapakkam | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Urapakkam, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  irumbuliyur: {
    metaTitle: "Family Clinic Near Irumbuliyur | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Irumbuliyur, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  selaiyur: {
    metaTitle: "Family Clinic Near Selaiyur | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Selaiyur, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  padappai: {
    metaTitle: "Family Clinic Near Padappai | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Padappai, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  chromepet: {
    metaTitle: "Family Clinic Near Chromepet | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Chromepet, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram for information about family healthcare and available medical services.",
  },
  kilambakkam: {
    metaTitle: "Family Clinic Near Kilambakkam | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Kilambakkam, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram to enquire about family healthcare and available medical services.",
  },
  mannivakkam: {
    metaTitle: "Family Clinic Near Mannivakkam | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near Mannivakkam, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram to enquire about family healthcare and available medical services.",
  },
  "west-tambaram": {
    metaTitle: "Family Clinic Near West Tambaram | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic near West Tambaram, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram to enquire about family healthcare and available medical services.",
  },
  "new-perungalathur": {
    metaTitle: "Family Clinic in New Perungalathur | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic in New Perungalathur, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics for information about family healthcare and available medical services.",
  },
  perungalathur: {
    metaTitle: "Family Clinic in Perungalathur | Revive Family Clinic",
    metaDescription:
      "Looking for a family clinic in Perungalathur, Chennai? Contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram to enquire about family healthcare and available medical services.",
  },
};

locations.forEach((location) => {
  const metadata = suppliedLocationContent[location.slug] || suppliedSeoMetadata[location.slug];
  if (metadata) Object.assign(location, metadata);
});

const getLocationBySlug = (slug) =>
  locations.find((location) => location.slug === slug);

module.exports = { locations, getLocationBySlug };
